import { render, staticRenderFns } from "./FileUploadConfig.vue?vue&type=template&id=08d462be&scoped=true"
import script from "./FileUploadConfig.vue?vue&type=script&lang=js"
export * from "./FileUploadConfig.vue?vue&type=script&lang=js"
import style0 from "./FileUploadConfig.vue?vue&type=style&index=0&id=08d462be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d462be",
  null
  
)

export default component.exports